export enum DeliveryOriginEnum {
  START = 'start',
  PLATFORM = 'Platform',
  MANUAL = 'Manual',
}

export enum ProductTypeEnum {
  RAWPRODUCT = 'RawProduct',
  MIXEDPRODUCT = 'MixedProduct',
}

export interface Delivery {
  id: number;
  deliveryOrigin: DeliveryOriginEnum;
  externalDeliveryId: string;
  deliveryType: string;
  deliveryDate: string;
  customerId: number;
  shipToId: number;
  deliveryLines: DeliveryLine[];
}

export interface DeliveryLine {
  id: string;
  externalUniqueIdentifier: string;
  externalProductId: string;
  productTitle: string;
  productType: ProductTypeEnum;
  unitVolumeType: string;
  unitsDelivered: number;
  unitsRemaining: number;
  isActive: boolean;
  currency: string;
  unitNettoPrice?: number;
  kgDelivered?: number;
  externalInvoiceId: string;
  invoiceDate: string;
  vatPercentage?: number;
  showInFinalSetup?: boolean;
}

export interface GetDeliveriesResponse {
  deliveries: Delivery[];
}

export interface ActiveDelivery {
  deliveryId: number;
  origin: DeliveryOriginEnum;
  activeDeliveryLineExternalUniqueIdentifiers: string[];
}

export interface ShowInFinalSetupDeliveryRequest {
  deliveryId: number;
  deliveryLineExternalUniqueIdentifier: string;
  showInFinalSetup: boolean;
}

export interface PostManualDeliveryRequest {
  id: number;
  deliveryDate: string;
  manualDeliveryLines: PostManualDeliveryLine[];
}

export interface PostManualDeliveryLine {
  id: string;
  cycleId?: number;
  externalUniqueIdentifier: string;
  externalProductId: string;
  productTitle: string;
  productType: ProductTypeEnum;
  unitVolumeType: string;
  unitsDelivered: number;
  isActive: boolean;
  currency: string;
  unitNettoPrice?: number;
  kgDelivered?: number;
  barnId?: number;
  externalInvoiceId: string;
  invoiceDate: string;
  vatPercentage?: number;
  showInFinalSetup?: boolean;
}
